<template src="./template.html"></template>

<script>
/* eslint-disable */
import ServiceGroup from "@/components/global/serviceGroup/index.vue";

export default {
  name: 'ToggleList',
  components: {
    ServiceGroup,
  },
  props: {
    shippingDate: {
      type: [String, Date],
      default: '',
    },
    list: {
      type: [Object, Array],
      default: {},
    },
    servicesAllowed: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedServices: {
      type: Array,
      default: [],
    },
    additionalFieldData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return{
      services: [],
      allowedProducts: [],
    };
  },
  created() {
    this.services = this.selectedServices;
  },
  methods: {
    isServiceGroupAllowed(serviceGroup) {
      let result = false;
      Object.keys(serviceGroup.services).forEach((key, index) => {
        if(this.servicesAllowed.indexOf(Number(serviceGroup.services[key].id)) > -1){
          result = true;
        }
      })
      return result;
    },
    extraFieldAdd(field){
      console.log('TOGGLELIST - extraFieldAdd')
      if(this.services.indexOf(field.serviceId) < 0){
        this.services.push(field.serviceId);
        this.$emit('servicesUpdate', {
          services: this.services,
          additionalFieldData: {...this.additionalFieldData, ...field.additionalData},
        });
      } else {
        this.$emit('extraFieldAdd', {...this.additionalFieldData, ...field.additionalData});
      }
    },
    serviceAdd(serviceInfo) {
      console.log('TOGGLELIST - serviceAdd')
      this.services.push(serviceInfo.serviceID);
      this.$emit('servicesUpdate', {
        services: this.services,
        additionalFieldData: this.additionalFieldData,
      });
    },
    serviceRemove(serviceInfo) {
      console.log('TOGGLELIST - serviceRemove')
      this.services.splice(this.services.indexOf(serviceInfo.serviceID), 1);
      let additional = JSON.parse(JSON.stringify({...this.additionalFieldData}));
      if(additional.hasOwnProperty([serviceInfo.serviceID])){
        delete additional[serviceInfo.serviceID];
      }

      this.$emit('servicesUpdate', {
        services: this.services,
        additionalFieldData: additional,
      });
    },
  },
}
</script>
